export default "__VITE_ASSET__B5m86$mV__"